/**
 * @Author Heriberto Monterrubio <heri185403@gmail.com>
 * @Date 2020-Oct-22
 *
 * bestgob-client - processes.module.js
 **/
import processesRequestModel from "../api/models/process/list.request";
import {Processes} from "../api";
import {processRequirementsRequest} from "../api/models";

const processesModule = {
    namespaced: true,
    state: {
        processes: null,
        categories: null,
        processRequirements: null,
        processRequirementsShow: true,
        processName: null
    },
    getters: {

    },
    actions: {
        async getProcesses({commit, dispatch}, request = processesRequestModel()){
            dispatch('alerts/showLoading', 'Obteniendo listado de procesos', {root: true})
            await dispatch('account/checkAuthExpiration', null, { root: true })

            Processes.getByCategory(request)
                .then(data => {
                    dispatch('alerts/hideLoading', null, {root: true})
                    commit('getProcessesSuccess', data)
                })
                .catch(error => {
                    dispatch('alerts/error', error.message, {root: true})
                })
        },

        async getCategories({commit, dispatch}){
            dispatch('alerts/showLoading', 'Obteniendo listado de categorías', {root: true})
            await dispatch('account/checkAuthExpiration', null, { root: true })

            Processes.getCategories()
                .then(data => {
                    dispatch('alerts/hideLoading', null, {root: true})
                    commit('getCategoriesSuccess', data)
                })
                .catch(error => {
                    dispatch('alerts/error', error.message, {root: true})
                })
        },

        async getProcessRequirements({commit, dispatch}, request = processRequirementsRequest()){
            dispatch('alerts/showLoading', 'Obteniendo información del proceso', {root: true})
            await dispatch('account/checkAuthExpiration', null, { root: true })

            Processes.getProcessRequirements(request.processId, request.invited, request.userId, request.sessionUser)
                .then(data => {
                    dispatch('alerts/hideLoading', null, {root: true})
                    commit('getRequirementsSuccess', data)
                })
                .catch(error => {
                    dispatch('alerts/error', error.message, {root: true})
                })

        },

        async getProcessDetails({commit, dispatch}, processId= 0){
            dispatch('alerts/showLoading', 'Obteniendo los detalles del proceso', {root: true})

            await dispatch('account/checkAuthExpiration', null, { root: true })

            Processes.getDetailsAndTasks(processId)
                .then(data => {
                    //dispatch('alerts/hideLoading', null, {root: true})
                    commit('getProcessDetailsSucccess', data)
                })
                .catch(error => {
                    dispatch('alerts/error', error.message, {root: true})
                })
        }
    },

    mutations: {
        getProcessesSuccess(state, processes){
            state.processes = processes
        },

        getCategoriesSuccess(state, categories){
            state.categories = categories
        },

        getRequirementsSuccess(state, processRequirements){
            state.processRequirements = processRequirements.contents
            state.processRequirementsShow = processRequirements.show
        },

        getProcessDetailsSucccess(state, processDetails){
            state.processName = processDetails.tareas.proceso
        },
    }
}

export default processesModule